// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.numberClassSelect .el-form-item__label .el-select .el-input__inner {\n  font-weight: bold;\n  border: none;\n  padding: 0;\n}\n.numberClassSelect.el-form-item {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
